import { render, staticRenderFns } from "./order-dispatch-status.vue?vue&type=template&id=8e69e55a"
import script from "./order-dispatch-status.vue?vue&type=script&lang=ts"
export * from "./order-dispatch-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports